import type { IconSvgObject } from './types';

const UngroupIcon: IconSvgObject = [
  ["path", { d: "M4 8V5C4 3.89543 4.89543 3 6 3H12C13.1046 3 14 3.89543 14 5V8C14 9.10457 13.1046 10 12 10H6C4.89543 10 4 9.10457 4 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 19V16C10 14.8954 10.8954 14 12 14H18C19.1046 14 20 14.8954 20 16V19C20 20.1046 19.1046 21 18 21H12C10.8954 21 10 20.1046 10 19Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default UngroupIcon;
